import { Box, Link, Typography } from "@mui/material";
import { faArrowUpRightFromSquare, faCodeBranch, faFileLines } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ArticleAuthorsList from "@/src/components/journal-site/articles/article-sidebar/article-authors-list/article-authors-list";
import SpanTypography from "@/src/mui-custom/typography/span-typography/span-typography";
import StyledDivider from "@/src/components/common/styled-divider/styled-divider";
import type Author from "@/src/_types/Authors/author";
import NextLink from "next/link";

const ArticleRelatedArticles = (
    {
        authors,
        articleTitle
    }: {
        authors: Author[];
        articleTitle: string;
    }
) => (
    <Box mt={1}>
        <StyledDivider
            label={"Search Relations"}
            icon={faCodeBranch}
        />
        <ArticleAuthorsList
            authors={authors || []}
        />
        <StyledDivider
            label={"Related Articles"}
            icon={faFileLines}
        />
        <Box pl={1} sx={{
            '& span': {
                fontSize: '.8rem',
                color: 'primary.main'
            },
            '& a > p': {
                fontSize: '.875rem'
            }
        }}>
            <Box display="flex" alignItems="baseline">
                <SpanTypography
                    mr={.25}
                    mt={.25}
                >
                    <FontAwesomeIcon
                        icon={faArrowUpRightFromSquare}
                    />
                </SpanTypography>
                <Link
                    component={NextLink}
                    href={`https://www.ncbi.nlm.nih.gov/sites/entrez?cmd=search&db=pubmed&term=${articleTitle.replace(' ', '%20')}`}
                >
                    <Typography>
                        Related Article in PubMed
                    </Typography>
                </Link>
            </Box>
            <Box display="flex" alignItems="baseline">
                <SpanTypography
                    mr={.25}
                    mt={.25}
                >
                    <FontAwesomeIcon
                        icon={faArrowUpRightFromSquare}
                    />
                </SpanTypography>
                <Link
                    component={NextLink}
                    href={`https://scholar.google.com/scholar?q=${articleTitle.replace(' ', '%20')}`}
                >
                    <Typography>
                        Related Article in Google Scholar
                    </Typography>
                </Link>
            </Box>
            <Box display="flex" alignItems="baseline">
                <SpanTypography
                    mr={.25}
                    mt={.25}
                >
                    <FontAwesomeIcon
                        icon={faArrowUpRightFromSquare}
                    />
                </SpanTypography>
                <Link
                    component={NextLink}
                    href={`https://scholar.google.com/scholar_alerts?view_op=create_alert_options&hl=en&alert_query=allintitle:%22${articleTitle.replace(' ', '%20')}%22&alert_params=hl%3Den%26as_sdt%3D2000`}
                >
                    <Typography>
                        Create Citation Alert via Google Reader
                    </Typography>
                </Link>
            </Box>
        </Box>
    </Box>
);

export default ArticleRelatedArticles;